import React from 'react';
import { Accordion } from 'cd-eft/components/common/Accordion';
import { observer } from 'mobx-react';
import { AnalysisComments } from '../AnalysisComments/AnalysisComments';
import { StructureComments } from '../StructureComments/StructureComments';
import './DesignComments.scss';

const DesignCommentsComponent = (props) => {
  return (
    <div className="contanier">
      <Accordion className="p-0 accordion-wrapper" headers={['Design Comments ']}>
        {props.projectClassId === 1 ? <StructureComments projectId={props.projectId} currentStructureList={props.currentStructureList} updateCallback={props.updateCallback} />
          : <AnalysisComments projectId={props.projectId} updateCallback={props.updateCallback} />}
      </Accordion>
    </div>
  );
};
export const DesignComments = observer(DesignCommentsComponent);
